/* global axios */
import ApiClient from './ApiClient';

class CompanyNotesAPI extends ApiClient {
  constructor() {
    super('companies', { accountScoped: true });
  }

  getUrl(companyId) {
    return `${this.url}/${companyId}/notes`;
  }

  get(companyId) {
    return axios.get(this.getUrl(companyId));
  }

  show(companyId, noteId) {
    return axios.get(`${this.getUrl(companyId)}/${noteId}`);
  }

  create(companyId, content) {
    return axios.post(this.getUrl(companyId), {
      company_note: { content },
    });
  }

  update(companyId, noteId, content) {
    return axios.patch(`${this.getUrl(companyId)}/${noteId}`, {
      company_note: { content },
    });
  }

  delete(companyId, noteId) {
    return axios.delete(`${this.getUrl(companyId)}/${noteId}`);
  }
}

export default new CompanyNotesAPI();
